import { render, staticRenderFns } from "./viewRetrospectiveWeeklyForm.vue?vue&type=template&id=64f80a22&scoped=true&"
import script from "./viewRetrospectiveWeeklyForm.vue?vue&type=script&lang=js&"
export * from "./viewRetrospectiveWeeklyForm.vue?vue&type=script&lang=js&"
import style0 from "./viewRetrospectiveWeeklyForm.vue?vue&type=style&index=0&id=64f80a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f80a22",
  null
  
)

export default component.exports